<template>
  <v-form class='createUserRoleForm mb-16' v-model='valid' ref='createUserRoleForm'>
    <v-container>
      <v-row>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='userRole.name'
            :error-messages='error.name'
            label='Name'
            placeholder='Name'
            autofocus
            ref="firstInput"
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12' class='radio-with-lable'>
          <label class="c-radio-label">Status</label>
          <v-radio-group v-model="userRole.status" row>
            <v-radio label="Active" :value="0" class="mt-0"></v-radio>
            <v-radio label="Inactive" :value="1" class="mt-0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <div class="role-main-wrapper" v-for="(right, index) in allRights" :key="index">
        <div class="role-header">
          <v-checkbox v-model="roleGroup" :label="right.display" @click="checkedAllCheckbox(index)" class="mt-0 pt-0" :value="index"></v-checkbox>
        </div>
        <div class="role-body">
          <v-row class="custom-row">
            <v-col cols='12' md='3' sm='6' xs='12' class='py-1' v-for="(r, i) in right.right" :key="i">
              <v-checkbox v-model="selectedRights[index]" :label="r.display_name" class="mt-0 pt-0" :value="r.name" @click="singleChecked(index)"></v-checkbox>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-container>
    <v-footer fixed>
      <v-col class="text-right">
        <v-btn color="primary" class="mr-2" @click="submit" small>{{ edit_id ? 'Update' : 'Add' }}</v-btn>
        <v-btn color="default" @click="reset" small>Reset</v-btn>
      </v-col>
    </v-footer>
  </v-form>
</template>
<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  created () {
    var id = ''
    const storageData = localStorage.getItem('clone_data')
    if (storageData) {
      const _storageData = JSON.parse(storageData)
      id = _storageData.module_id
    }
    localStorage.removeItem('clone_data')
    if (this.$route.params.id) {
      id = this.$route.params.id
    }
    this.getDataById(id)
  },
  data: function () {
    return {
      valid: false,
      edit_id: undefined,
      userRole: { status: 0 },
      error: {},
      checkbox: false,
      allRights: {},
      selectedRights: [],
      roleGroup: []
    }
  },
  methods: {
    getDataById (id) {
      this.$axios.post('getUserRoleWithAllRight', { userRoleId: id }).then((res) => {
        this.allRights = res.data.all_right
        const emptyRightObject = {}
        Object.keys(this.allRights).map((r) => {
          emptyRightObject[r] = []
        })
        this.selectedRights = emptyRightObject
        if (res.data.user_role_data) {
          this.userRole = res.data.user_role_data
        }
        if (res.data.user_role_to_right) {
          this.selectedRights = { ...this.selectedRights, ...res.data.user_role_to_right }
          Object.keys(this.selectedRights).map((r) => {
            if (this.selectedRights[r].length === this.allRights[r].right.length) {
              this.roleGroup.push(r)
            }
          })
        }
        if (this.$route.params.id) {
          this.edit_id = this.$route.params.id
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    submit () {
      const route = this.edit_id ? 'saveUserRole/' + this.edit_id : 'saveUserRole'
      this.$axios.post(route, { userRole: this.userRole, right: this.selectedRights }).then((res) => {
        this.$eventBus.$emit('$globalSnackbar', 'success', res.data.success_description)
        if (this.edit_id) {
          this.$router.push('/userRole')
        } else {
          this.reset()
        }
      }).catch((err) => {
        if (err.response.status === 422) {
          this.error = err.response.data.error_data
          console.log(this.error)
        } else {
          this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
        }
      })
    },
    reset () {
      this.$refs.createUserRoleForm.reset()
      setTimeout(() => {
        this.userRole = { status: 0 }
        this.error = {}
        this.selectedRights = {}
        this.$refs.firstInput.focus()
      }, 300)
    },
    checkedAllCheckbox (groupName = '') {
      if (this.roleGroup.indexOf(groupName) !== -1) {
        const groupRights = this.allRights[groupName].right.map((r) => {
          return r.name
        })
        this.selectedRights[groupName] = [...groupRights]
      } else {
        this.selectedRights[groupName] = []
      }
    },
    singleChecked (groupName = '') {
      const groupNameIndex = this.roleGroup.indexOf(groupName)
      if (this.selectedRights[groupName].length === this.allRights[groupName].right.length) {
        if (groupNameIndex === -1) {
          this.roleGroup.push(groupName)
        }
      } else {
        this.roleGroup.splice(groupNameIndex, 1)
      }
    }
  }
}
</script>
<style lang='scss'>
.createUserRoleForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.createUserRoleForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.custom-row .v-input__slot {
  margin-bottom: 0px;
}
.role-main-wrapper {
  border: 1px solid #eee;
  margin-bottom: 20px;
  .role-header {
    background-color: #eee;
    padding: 10px;
  }
  .v-input__slot {
    margin-bottom: 0px;
  }
  .v-messages {
    display: none;
  }
  .role-body {
    padding: 10px;
  }
}
</style>
